import {
  Autocomplete,
  Button,
  Card,
  CardContent,
  Grid,
  Divider,
  MenuItem,
  TextField,
  Typography,
  TextareaAutosize,
  Table,
} from "@mui/material";
import "react-toastify/dist/ReactToastify.css";
import React, { useEffect, useState } from "react";
import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
import DeleteIcon from "@mui/icons-material/Delete";
import { Navigate, useNavigate, useLocation } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import CustomLabel from "../../../CustomLable";
import api from "../../../utils/Url";
import { getId, getISTDate } from "../../../utils/Constant";

type Props = {};



const CreateQualityCheck = (props: Props) => {
  let navigate = useNavigate();
  const { t } = useTranslation();
  const { defaultValues } = getISTDate();

  const [toaster, setToaster] = useState(false);
  const [vendorData, setVendorData] = useState([]);
  const [vendorDetail, setVendorDetail] = useState<any>();
  const initialRowData: any = {
    id: -1,
    qcId: 0,
    mrnId: 0,
    orderId: 0,
    orderNo: "",
    itemId: 0,
    mrnQty: 0,
    acceptQty: 0,
    rejectQty: 0,
    rate: 0,
    amount: 0,
    gstId: 0,
    gstRate: 0,
    cgst: 0,
    sgst: 0,
    igst: 0,
    netAmount: 0,
    reason: "",
    batchNo: "",
    totalGst: 0,

    item: {},
  };
  const [tableData, setTableData] = useState([{ ...initialRowData }]);
  const [taxData, setTaxData] = useState<any>([]);
  const [qcOptions, setQcOptions] = useState([]);
  const [itemOption, setitemOption] = useState<any>([]);
  const [mrnNoOptions, setmrnNoOptions] = useState([
    { value: "-1", label: t("text.selectMRN") },
  ]);
  const [storeOptions, setstoreOptions] = useState([]);

  const mrnTypeOption = [
    { value: "-1", label: t("text.selectMRN") },
    { value: "1", label: "Bill" },
    { value: "2", label: "Challan" },
  ];

  const Userid = getId();

  useEffect(() => {
    getMRNNo();
    getVendorData();
    getTaxData();
    GetitemData();
    GetstoreData();
    GetmrnData();
    GetQcData();
  }, []);


  const GetmrnData = async () => {
    try {
      const collectData = {
        "mrnId": -1,
        "mrnNo": "",
        "vendorId": -1,
        "purOrderId": -1,
        "fromDate": null,
        "toDate": null,
        "show": true,
        "exportOption": "",
        "type": 0
      }
      const response = await api.post(`Mrn/GetMrn`, collectData);
      const data = response.data.data;
      if (data && data.length > 0) {


        // Set QC number in formik and options

        const arr = data.map((item: any) => ({
          label: `${item.mrnNo} - ${item.vendorName} `,
          value: item.mrnId,
          vendorId: item.vendorId,
          vendorName: item.vendorName,
          bill_ChalanNo: item.bill_ChalanNo,
          shipmentNo: item.shipmentNo,
          mrnNo: item.mrnNo


        }));

        setmrnNoOptions(arr);
      }
    } catch (error) {
      console.error("Error fetching QC data:", error);
    }
  };

  const GetstoreData = async () => {
    try {
      const collectData = {
        "id": -1,
        "unit": -1
      };
      const response = await api.post(`StoreMaster/GetStoreMaster`, collectData);
      const data = response.data.data;
      if (data && data.length > 0) {

        const arr = data.map((item: any) => ({
          label: item.storeName,
          value: item.id,
        }));

        setstoreOptions(arr);
      }
    } catch (error) {
      console.error("Error fetching QC data:", error);
    }
  };


  const GetQcData = async () => {
    try {
      const response = await api.get(`Qc/GetMaxQcNo`,
        { headers: { 'QcId': '-1' } },
      );

      const data = response.data.data;

      // Assuming the first item in data has the latest QC number
      if (data && data.length > 0) {
        const latestQcNo = data[0]["qcNo"];

        // Set QC number in formik and options
        formik.setFieldValue('qcNo', latestQcNo);
        const arr = data.map((item: any) => ({
          label: item.qcNo,
          value: item.qcId,
        }));

        setQcOptions(arr);
      }
    } catch (error) {
      console.error("Error fetching QC data:", error);
    }
  };


  const getMRNNo = async () => {
    const result = await api.get(`Mrn/GetMaxcMrnNo`);
    if (result?.data.status === 1) {
      formik.setFieldValue("mrnNo", result.data.data[0]["mrnNo"]);
    }
  };

  const GetitemData = async () => {
    const collectData = {
      itemMasterId: -1,
    };
    const response = await api.post(`ItemMaster/GetItemMaster`, collectData);
    const data = response.data.data;
    const arr =
      data?.map((item: any) => ({
        label: `${item.itemName}`,
        value: item.itemMasterId,
        details: item,
      })) || [];
    setitemOption([{ value: -1, label: t("text.selectItem"), details: "" }, ...arr]);
  };


  const getVendorData = async () => {
    const result = await api.post(`VendorMaster/Ge3tVendorMaster`, {
      venderId: -1,
    });
    if (result.data.isSuccess) {
      const arr =
        result?.data?.data?.map((item: any) => ({
          label: item.name,
          value: item.venderId,
          //details: item,
        })) || [];
      console.log("dataaaaaa", result.data.data)

      setVendorData([
        { value: "-1", label: t("text.SelectVendor") },
        ...arr,
      ] as any);
    }
  };

  const getTaxData = async () => {
    const result = await api.post(`TaxMaster/GetTaxMaster`, {
      taxId: -1,
    });
    if (result.data.isSuccess) {
      const arr =
        result?.data?.data?.map((item: any) => ({
          label: `${item.taxPercentage}`,
          value: item.taxId,
        })) || [];

      setTaxData([{ value: "-1", label: t("text.tax") }, ...arr]);
    }
  };

  const handleVendorSelect = (event: any, newValue: any) => {
    console.log(newValue?.value);

  };

  const handleInputChange = (index: number, field: string, value: any) => {
    const updatedItems = [...tableData];
    let item = { ...updatedItems[index] };

    if (field === "itemId") {
      const selectedItem = itemOption.find(
        (option: any) => option.value === value
      );
      if (selectedItem) {
        item = {
          ...item,
          itemId: selectedItem.value,
          itemName: selectedItem.label,
          item: selectedItem.details,
        };
      }
    } else if (field === "batchNo") {
      item.batchNo = value.toString();
    } else if (field === "mrnQty") {
      item.mrnQty = value === "" ? 0 : parseFloat(value);
    } else if (field === "acceptQty") {
      item.acceptQty = value === "" ? 0 : parseFloat(value);
    } else if (field === "rejectQty") {
      item.rejectQty = value === "" ? 0 : parseFloat(value);
    } else if (field === "rate") {
      item.rate = value === "" ? 0 : parseFloat(value);
    } else if (field === "totalGst") {
      item.totalGst = value === "" ? 0 : parseInt(value);
    }
    else if (field === "gstId") {
      const selectedTax: any = taxData.find((tax: any) => tax.value === value);
      if (selectedTax) {
        item.gstRate = parseFloat(selectedTax.label) || 0;
        item.gstId = selectedTax.value || 0;
        item.cgstid = selectedTax.value || 0;
        item.sgstid = selectedTax.value || 0;
        item.igstid = 0;
      }
    } else {
      item[field] = value;
    }

    // Calculate amount if required fields are filled
    if (item.acceptQty && item.rate) {
      item.amount = (parseFloat(item.acceptQty) || 0) * (parseFloat(item.rate) || 0);
    }

    // Calculate GST and total amount if gstRate is selected
    if (item.gstRate) {
      item.totalGst = ((item.amount * (parseFloat(item.gstRate) || 0)) / 100).toFixed(2);
      item.sgst = (parseFloat(item.totalGst) / 2).toFixed(2);
      item.cgst = (parseFloat(item.totalGst) / 2).toFixed(2);
      item.igst = 0;
    }

    // Calculate net amount
    item.netAmount = (parseFloat(item.amount) + parseFloat(item.totalGst || "0")).toFixed(2);

    formik.setFieldValue("totalAmount", item.netAmount);

    updatedItems[index] = item;
    setTableData(updatedItems);
    updateTotalAmounts(updatedItems);

    if (isRowFilled(item) && index === updatedItems.length - 1) {
      addRow();
    }
  };


  console.log("tableData.....", tableData);

  const isRowFilled = (row: any) => {
    console.log("isRowFilled", row);
    return (
      row.orderNo &&
      row.itemId &&
      row.batchNo &&
      row.balQuantity > 0 &&
      row.quantity > 0 &&
      row.rate > 0
    );
  };

  const updateTotalAmounts = (data: any[]) => {
    console.log("updateTotalAmounts", data);
    const totals = data.reduce(
      (acc, row) => {
        acc.totalAmount += parseFloat(row.amount) || 0;
        acc.totalCGST += parseFloat(row.cgst) || 0;
        acc.totalSGST += parseFloat(row.sgst) || 0;
        acc.totalIGST += parseFloat(row.igst) || 0;
        acc.totalGrossAmount += parseFloat(row.netAmount) || 0;
        return acc;
      },
      {
        totalAmount: 0,
        totalCGST: 0,
        totalSGST: 0,
        totalIGST: 0,
        totalGrossAmount: 0,
      }
    );

    formik.setValues({
      ...formik.values,
      ...totals,
    });
  };

  const deleteRow = (index: number) => {
    if (tableData.length === 1) {
      setTableData([{ ...initialRowData }]);
    } else {
      const newData = tableData.filter((_, i) => i !== index);
      setTableData(newData);
    }
    updateTotalAmounts(tableData);
  };

  const addRow = () => {
    setTableData([...tableData, { ...initialRowData }]);
  };

  const formik = useFormik({
    initialValues: {
      qcId: 0,
      qcNo: "",
      qcDate: defaultValues,
      mrnId: 0,
      storeid: 0,
      mrnType: "",
      vendorId: 0,
      bill_ChalanNo: "",
      bill_ChalanDate: defaultValues,
      shipmentNo: "",
      remark: "",
      totalAmount: 0,
      totalCGST: 0,
      totalSGST: 0,
      totalIGST: 0,
      totalGrossAmount: 0,
      disPer: 0,
      disAmt: 0,
      netAmount: 0,
      createdBy: Userid,
      updatedBy: Userid,
      createdOn: defaultValues,
      updatedOn: defaultValues,
      companyId: 0,
      fyId: 0,
      qcDetail: [],
      srn: 0,
      amount: 0,
      vendor: "",
      mrnDate: defaultValues,
      mrnNo: "",
      storeName: ""
    },

    validationSchema: Yup.object({
      qcDate: Yup.string()
        .required(t("text.reqQcDate")),
      bill_ChalanNo: Yup.string()
        .required(t("text.reqBillNum")),
      bill_ChalanDate: Yup.string()
        .required(t("text.reqBillDate")),
    }),


    onSubmit: async (values: any) => {

      const isFirstRowDefault = tableData[0] &&
        tableData[0].id === -1 &&
        tableData[0].qcId === 0 &&
        tableData[0].mrnId === 0 &&
        tableData[0].orderId === 0 &&
        tableData[0].orderNo === "" &&
        tableData[0].itemId === 0 &&
        tableData[0].mrnQty === "" &&
        tableData[0].acceptQty === "" &&
        tableData[0].rejectQty === "" &&
        tableData[0].rate === "" &&
        tableData[0].amount === "" &&
        tableData[0].gstId === "" &&
        tableData[0].gstRate === "" &&
        tableData[0].cgst === "" &&
        tableData[0].sgst === "" &&
        tableData[0].igst === "" &&
        tableData[0].gst === "" &&
        tableData[0].netAmount === "" &&
        tableData[0].reason === "" &&
        tableData[0].batchNo === "" &&

        Object.keys(tableData[0].item).length === 0;

      if (isFirstRowDefault) {
        alert("Please add values in the table before submitting.");
        return;
      }

      values.qcDetail = tableData

      // values.vendor = vendorDetail;

      const response = await api.post(`Qc/AddUpdateQc`,
        values

      );
      if (response.data.status === 1) {
        setToaster(false);
        toast.success(response.data.message);
        navigate("/Inventory/QualityCheck");
      } else {
        setToaster(true);
        toast.error(response.data.message);
      }
    },
  });

  const back = useNavigate();

  const getPurchaseOrderByIndent = async (id: any) => {
    const collectData = {
      "mrnId": id,
      "mrnNo": "",
      "vendorId": -1,
      "purOrderId": -1,
      "fromDate": null,
      "toDate": null,
      "show": true,
      "exportOption": "",
      "type": 0
    }


    const response = await api.post(`Mrn/GetMrn`, collectData);
    //const data = response.data.data;
    const transData = response?.data?.data[0]["mrnDetail"];
    console.log("mrnDetail", transData);

    let arr: any = [];
    for (let i = 0; i < transData.length; i++) {
      arr.push({
        id: transData[i]["id"],
        qcId: transData[i]["mrnId"],
        mrnId: transData[i]["mrnId"],
        mrnNo: formik.values.mrnNo,
        reason: formik.values.remark,
        orderId: transData[i]["orderId"],
        orderNo: transData[i]["orderNo"],
        itemId: transData[i]["itemId"],
        itemName: transData[i]["itemName"],
        // mrnQty: transData[i]["quantity"],
        mrnQty: Number(transData[i]["quantity"]) + Number(transData[i]["balQuantity"]),
        acceptQty: transData[i]["quantity"],
        rejectQty: transData[i]["balQuantity"],
        rate: transData[i]["rate"],
        amount: transData[i]["amount"],
        gst: transData[i]["gst"],
        gstId: transData[i]["gstId"],
        gstRate: transData[i]["gstRate"],
        cgst: transData[i]["cgst"],
        sgst: transData[i]["sgst"],
        igst: transData[i]["igst"],
        netAmount: transData[i]["netAmount"],
        totalGst: transData[i]["totalGst"],
        batchNo: transData[i]["batchNo"],
        unitId: transData[i]["unitId"],
        unitName: transData[i]["unitName"],

      });
    }
    // arr.push({ ...initialRowData });
    setTableData(arr);
  };


  console.log("formik.values", formik.values);

  return (
    <div>
      <div
        style={{
          padding: "-5px 5px",
          backgroundColor: "#ffffff",
          borderRadius: "5px",
          border: ".5px solid #FF7722",
          marginTop: "3vh",
        }}
      >
        <CardContent>
          <Typography
            variant="h5"
            textAlign="center"
            style={{ fontSize: "18px", fontWeight: 500 }}
          >
            {t("text.createQualityCheck")}
          </Typography>

          <Grid item sm={4} xs={12}>
            <Typography style={{ marginTop: "-75px" }}>
              <Button
                type="submit"
                onClick={() => back(-1)}
                variant="contained"
                style={{
                  marginBottom: 15,
                  marginTop: "45px",
                  backgroundColor: `var(--header-background)`,
                  width: 20,
                }}
              >
                <ArrowBackSharpIcon />
              </Button>
            </Typography>
          </Grid>
          <Divider />
          <br />
          <form onSubmit={formik.handleSubmit}>
            {toaster === false ? "" : <ToastApp />}
            <Grid item xs={12} container spacing={2}>
              {/* Qc No Field */}
              <Grid item lg={4} xs={12}>
                <TextField
                  id="qcNo"
                  name="qcNo"
                  label={
                    <CustomLabel text={t("text.qcNo")} required={false} />
                  }
                  value={formik.values.qcNo}
                  placeholder={t("text.qcNo")}
                  size="small"
                  fullWidth
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </Grid>
              {/* Qc Date Field */}
              <Grid item lg={4} xs={12}>
                <TextField
                  id="qcDate"
                  name="qcDate"
                  label={
                    <CustomLabel text={t("text.qcDate")} required={true} />
                  }
                  value={formik.values.qcDate}
                  placeholder={t("text.qcDate")}
                  size="small"
                  fullWidth
                  type="date"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  InputLabelProps={{ shrink: true }}
                />
                {formik.touched.qcDate && formik.errors.qcDate && (
                  <div style={{ color: "red", margin: "5px" }}>{String(formik.errors.qcDate)}</div>
                )}

              </Grid>
              {/* MRN No DropDown */}
              <Grid item lg={4} xs={12}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={mrnNoOptions}
                  fullWidth
                  size="small"
                  onChange={(event: any, newValue: any) => {
                    console.log(newValue?.value);
                    formik.setFieldValue('mrnNo', newValue?.mrnNo);
                    formik.setFieldValue('mrnId', newValue?.value);
                    formik.setFieldValue('vendorId', newValue?.vendorId);
                    formik.setFieldValue('vendor', newValue?.vendorName);
                    formik.setFieldValue('bill_ChalanNo', newValue?.bill_ChalanNo);
                    formik.setFieldValue('shipmentNo', newValue?.shipmentNo);



                    getVendorData()



                    getPurchaseOrderByIndent(newValue?.value)
                    //formik.setFieldValue("mrnNo", newValue?.value.toString());
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <CustomLabel
                          text={t("text.mrnNo")}
                          required={false}
                        />
                      }
                    />
                  )}
                />
              </Grid>
              {/* Challan No Field */}
              <Grid item lg={4} xs={12}>
                <TextField
                  id="bill_ChalanNo"
                  name="bill_ChalanNo"
                  label={
                    <CustomLabel
                      text={t("text.bill_ChalanNo")}
                      required={true}
                    />
                  }
                  value={formik.values.bill_ChalanNo}
                  placeholder={t("text.bill_ChalanNo")}
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.bill_ChalanNo && formik.errors.bill_ChalanNo && (
                  <div style={{ color: "red", margin: "5px" }}>{String(formik.errors.bill_ChalanNo)}</div>
                )}

              </Grid>
              {/* Challan Date Field */}
              <Grid item lg={4} xs={12}>
                <TextField
                  id="bill_ChalanDate"
                  name="bill_ChalanDate"
                  label={
                    <CustomLabel
                      text={t("text.bill_ChalanDate")}
                      required={true}
                    />
                  }
                  type="date"
                  value={formik.values.bill_ChalanDate}
                  placeholder={t("text.bill_ChalanDate")}
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  InputLabelProps={{ shrink: true }}
                />
                {formik.touched.bill_ChalanDate && formik.errors.bill_ChalanDate && (
                  <div style={{ color: "red", margin: "5px" }}>{String(formik.errors.bill_ChalanDate)}</div>
                )}

              </Grid>
              {/* Shipment No Field */}
              <Grid item lg={4} xs={12}>
                <TextField
                  id="shipmentNo"
                  name="shipmentNo"
                  label={
                    <CustomLabel text={t("text.shipmentNo")} required={false} />
                  }
                  value={formik.values.shipmentNo}
                  placeholder={t("text.shipmentNo")}
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </Grid>
              {/* Store DropDown */}
              <Grid item lg={4} xs={12}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={storeOptions}
                  fullWidth
                  size="small"
                  onChange={(event: any, newValue: any) => {
                    console.log(newValue?.value);

                    formik.setFieldValue("storeName", newValue?.label);
                    formik.setFieldValue("storeid", newValue?.value);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <CustomLabel
                          text={t("text.storeName")}
                          required={false}
                        />
                      }
                    />
                  )}
                />
              </Grid>

              <Grid container item spacing={2} xs={12} md={12} lg={12}>
                <Grid item lg={12} xs={12}>
                  <Typography
                    variant="h6"
                    textAlign="center"
                    fontWeight="bold"
                    fontSize="20px"
                    style={{ textDecoration: "underline" }}
                  >
                    {t("text.Vendordetails")}
                  </Typography>
                </Grid>
                <Divider />

                <Grid item lg={4} xs={12} md={6}>
                  <Autocomplete
                    disablePortal
                    size="small"
                    id="combo-box-demo"
                    options={vendorData}
                    value={vendorData.find((opt: any) => opt.value === formik.values.vendorId) || null}
                    onChange={(event: any, newValue: any) => {
                      console.log(newValue?.value);

                      formik.setFieldValue("vendor", newValue?.label || "");
                      formik.setFieldValue("vendorId", newValue?.value || -1);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={
                          <CustomLabel
                            text={t("text.SelectVendor")}
                            required={false}
                          />
                        }
                      />
                    )}
                  />
                </Grid>

              </Grid>

              <Grid item xs={12} md={12} lg={12}>
                <Table
                  style={{
                    borderCollapse: "collapse",
                    width: "100%",
                    border: "1px solid black",
                  }}
                >
                  <thead
                    style={{ backgroundColor: "#2196f3", color: "#f5f5f5" }}
                  >
                    <tr>
                      <th
                        style={{
                          border: "1px solid black",
                          textAlign: "center",
                          padding: "5px",
                        }}
                      >
                        {t("text.Action")}
                      </th>

                      <th
                        style={{
                          border: "1px solid black",
                          textAlign: "center",
                          padding: "5px",
                        }}
                      >
                        {t("text.ItemName")}
                      </th>
                      <th
                        style={{
                          border: "1px solid black",
                          textAlign: "center",
                          padding: "5px",
                        }}
                        title="MRN Quantity"
                      >
                        {t("text.MrnQty")}
                      </th>
                      <th
                        style={{
                          border: "1px solid black",
                          textAlign: "center",
                          padding: "5px",
                        }}


                        title="Accept Quantity"
                      >
                        {t("text.AcceptQty")}
                      </th>
                      <th
                        style={{
                          border: "1px solid black",
                          textAlign: "center",
                          padding: "5px",
                        }}

                        title="Reject Quantity"
                      >
                        {t("text.RejectQty")}
                      </th>
                      <th
                        style={{
                          border: "1px solid black",
                          textAlign: "center",
                          padding: "5px",
                        }}
                      >
                        {t("text.Rate")}
                      </th>
                      <th
                        style={{
                          border: "1px solid black",
                          textAlign: "center",
                          padding: "5px",
                        }}
                      >
                        {t("text.Amount")}
                      </th>
                      <th
                        style={{
                          border: "1px solid black",
                          textAlign: "center",
                          padding: "5px",
                        }}
                      >
                        {t("text.GSTRate")}
                      </th>
                      {

                        <th
                          style={{
                            border: "1px solid black",
                            textAlign: "center",
                            padding: "5px",
                          }}
                        >
                          {t("text.totalTax")}
                        </th>
                      }
                      <th
                        style={{
                          border: "1px solid black",
                          textAlign: "center",
                          padding: "5px",
                        }}
                      >
                        {t("text.NetAmount")}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {tableData.map((row, index) => (
                      <tr key={row.id} style={{ border: "1px solid black" }}>
                        <td
                          style={{
                            border: "1px solid black",
                            textAlign: "center",
                          }}
                        >
                          <DeleteIcon
                            onClick={() => deleteRow(index)}
                            style={{ cursor: "pointer" }}
                          />
                        </td>
                        <td
                          style={{
                            border: "1px solid black",
                            // textAlign: "center",
                            width: "20%"
                          }}
                        >
                          <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            options={itemOption}
                            value={
                              itemOption.find(
                                (opt: any) => opt.value == row.itemId
                              ) || null
                            }
                            fullWidth
                            size="small"
                            onChange={(e: any, newValue: any) =>
                              handleInputChange(
                                index,
                                "itemId",
                                newValue?.value
                              )
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                // label={
                                //   <CustomLabel
                                //     text={t("text.selectItem")}
                                //     required={false}
                                //   />
                                // }
                                placeholder={t("text.selectItem")}
                              />
                            )}
                          />
                        </td>


                        <td
                          style={{
                            border: "1px solid black",
                            textAlign: "center",
                          }}
                        >
                          <TextField
                            size="small"

                            value={
                              row.mrnQty
                            }
                            onChange={(e) => handleInputChange(index, "mrnQty", e.target.value)}
                          />
                        </td>
                        <td
                          style={{
                            border: "1px solid black",
                            textAlign: "center",
                          }}
                        >
                          <TextField
                            size="small"
                            value={row.acceptQty}
                            onChange={(e) => handleInputChange(index, "acceptQty", e.target.value)}
                            inputProps={{ step: "any", min: "0" }}
                          />
                        </td>
                        <td
                          style={{
                            border: "1px solid black",
                            textAlign: "center",
                          }}
                        >
                          <TextField
                            size="small"
                            value={Number(row.mrnQty) - Number(row.acceptQty)}
                            onChange={(e) => {
                              const newvalue = Number(row.mrnQty) - Number(row.acceptQty)
                              handleInputChange(index, "rejectQty", newvalue)
                            }}
                            inputProps={{ readOnly: true }}
                          />
                        </td>
                        <td
                          style={{
                            border: "1px solid black",
                            textAlign: "center",
                          }}
                        >
                          <TextField
                            size="small"
                            value={row.rate}
                            onChange={(e) => handleInputChange(index, "rate", e.target.value)}
                            inputProps={{ readOnly: true }}
                          />
                        </td>
                        <td
                          style={{
                            border: "1px solid black",
                            textAlign: "center",
                          }}
                        >
                          <TextField
                            value={row.amount}
                            size="small"
                            inputProps={{ readOnly: true }}
                          />
                        </td>
                        <td
                          style={{
                            border: "1px solid black",
                            textAlign: "center",
                          }}
                        >
                          <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            options={taxData}
                            value={
                              taxData.find((opt: any) => opt.value === row.gstId) || null
                            }
                            fullWidth
                            size="small"
                            onChange={(e: any, newValue: any) =>
                              handleInputChange(index, "gstId", newValue?.value)
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                // label={
                                //   <CustomLabel
                                //     text={t("text.tax")}
                                //     required={false}
                                //   />
                                // }
                                placeholder={t("text.tax")}
                              />
                            )}
                          />
                        </td>
                        <td
                          style={{
                            border: "1px solid black",
                            textAlign: "center",
                          }}
                        >
                          <TextField
                            value={row.totalGst}
                            onChange={(e: any) =>
                              handleInputChange(index, "totalGst", row.totalGst)
                            }
                            size="small"
                            inputProps={{ readOnly: true }}
                          />
                        </td>

                        <td
                          style={{
                            border: "1px solid black",
                            textAlign: "center",
                          }}
                        >
                          <TextField
                            value={row.netAmount}
                            size="small"
                            inputProps={{ readOnly: true }}
                          />
                        </td>
                      </tr>

                    ))}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colSpan={9} style={{ textAlign: "right", fontWeight: "bold" }}>
                        Total Amount:
                      </td>
                      <td style={{ textAlign: "center", border: "1px solid black" }}>
                        {tableData.reduce((acc, row) => acc + (parseFloat(row.amount) || 0), 0).toFixed(2)}
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={9} style={{ textAlign: "right", fontWeight: "bold" }}>
                        GST Amount:
                      </td>
                      <td style={{ textAlign: "center", border: "1px solid black" }}>
                        {tableData.reduce((acc, row) => acc + (parseFloat(row.totalGst) || 0), 0).toFixed(2)}
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={9} style={{ textAlign: "right", fontWeight: "bold" }}>
                        Net Amount:
                      </td>
                      <td style={{ textAlign: "center", border: "1px solid black" }}>
                        {tableData.reduce((acc, row) => acc + (parseFloat(row.netAmount) || 0), 0).toFixed(2)}
                      </td>
                    </tr>
                  </tfoot>
                </Table>
              </Grid>



              <Grid item xs={12} md={12} lg={12}>
                <TextareaAutosize
                  placeholder="Remark"
                  minRows={1}
                  onChange={(e: any) => formik.setFieldValue("remark", e.target.value)}
                  style={{
                    width: "100%",
                    height: "auto",
                    border: "1px solid #ccc",
                    padding: "8px",
                    borderRadius: "4px",
                    fontSize: "16px",
                    resize: "none",
                  }}
                />
              </Grid>

              <Grid item lg={6} sm={6} xs={12}>
                <Button
                  type="submit"
                  fullWidth
                  style={{
                    backgroundColor: `var(--header-background)`,
                    color: "white",
                    marginTop: "10px",
                  }}
                >
                  {t("text.save")}
                </Button>
              </Grid>

              <Grid item lg={6} sm={6} xs={12}>
                <Button
                  type="reset"
                  fullWidth
                  style={{
                    backgroundColor: "#F43F5E",
                    color: "white",
                    marginTop: "10px",
                  }}
                  onClick={(e: any) => formik.resetForm()}
                >
                  {t("text.reset")}
                </Button>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </div>
    </div>
  );
};

export default CreateQualityCheck;
